const tooltip = {
  root: {
    gutter: '{spacing.xxs}',
    padding: '{spacing.xxs} {spacing.xs}',
    borderRadius: '{overlay.popover.border.radius}',
    fontSize: '14px',
    lineHeight: '18px',
  },
  colorScheme: {
    light: {
      root: {
        background: '{dark}',
        color: '{white}',
      },
    },
    dark: {
      root: {
        background: '{gray.scale.700}',
        color: '{gray.scale.0}',
      },
    },
  },
};

export default tooltip;
